import { StaffApiSchema } from "../../api_utils";

type WorkflowEvaluation = StaffApiSchema.components["schemas"]["WorkflowEvaluation"];
type AlloyEvaluation = StaffApiSchema.components["schemas"]["AlloyEvaluationModel"];

// Returns TransactionEvaluation (Alloy) description if the FI has third party evaluations
// Returns WorkflowEvaluation description otherwise
export const getEvaluationDescription = ({
  evaluations,
  alloy_evaluations,
}: {
  evaluations?: WorkflowEvaluation[];
  alloy_evaluations?: AlloyEvaluation[];
}) => {
  // We only support one Alloy evaluation despite its array type
  const alloyEvaluation = alloy_evaluations?.[0];
  if (alloyEvaluation) {
    return alloyEvaluation.outcome_reasons.length > 1
      ? `${alloyEvaluation.outcome_reasons.length} issues`
      : alloyEvaluation.outcome_reasons[0];
  }

  if (evaluations?.length) {
    return evaluations.length > 1
      ? `${evaluations.length} issues`
      : evaluations[0].workflow_rule.description;
  }
  // This should be rare
  return "No issues found";
};
